import { useTenant } from "@/contexts/TenantContext";
import { Sparkles } from "lucide-react";

/** Reusable placeholder for Phase 2 modules not yet built. Everything wired into the sidebar. */
export default function ComingSoon({ title, description, icon: Icon = Sparkles, color = "blue", features = [] }) {
  const { activeTenant } = useTenant();
  return (
    <div className="p-8 max-w-4xl mx-auto" data-testid={`coming-soon-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="mb-8 fade-up">
        <div className="n-label">Nariai · {activeTenant?.name}</div>
        <h1 className="font-cab font-black text-5xl tracking-tight mt-1">{title}</h1>
        <p className="text-[var(--n-text-sec)] mt-3 text-lg">{description}</p>
      </div>

      <div className="n-card p-8 fade-up delay-1">
        <div className="flex items-start gap-6">
          <div className={`w-16 h-16 rounded-2xl flex items-center justify-center bg-[var(--n-${color}-soft)] shrink-0`}>
            <Icon size={28} className={`text-[var(--n-${color})]`}/>
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-2">
              <span className={`n-chip n-chip-${color}`}>Coming soon</span>
              <span className="text-xs text-[var(--n-text-muted)]">In development · roadmap Phase 2</span>
            </div>
            <div className="mt-4 text-[var(--n-text)]">
              This module is wired into your Nariai workspace. Here&apos;s what will ship:
            </div>
            <ul className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-2">
              {features.map((f) => (
                <li key={f} className="flex items-center gap-2 text-sm text-[var(--n-text-sec)]">
                  <span className={`text-[var(--n-${color})]`}>✔</span> {f}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
